import instance from './axios';
import {LOGIN,
        ADD_NOTICE_TYPE, GET_NOTICE_TYPE_LIST, EDIT_NOTICE_TYPE, EDIT_NOTICE_TYPE_STATUS, DELETE_NOTICE_TYPE, 
        ADD_DEPOTS, GET_DEPOTS_LIST, EDIT_DEPOTS, EDIT_DEPOTS_STATUS, DELETE_DEPOTS,
        GET_USER_LIST, ADD_USER, EDIT_USER, EDIT_USER_STATUS, DELETE_USER, ADD_CSV_BULK_USERS,
        GET_DRIVER_LIST, CHANGE_DRIVER_DEPOTS,
        GET_NOTICE_LIST, GET_NOTICE_TOTALS, ADD_NOTICE, EDIT_NOTICE, DELETE_NOTICE, CHANGE_NOTICE_STATUS,NOTICE_VIEW_REPORT
} from './endPoint';
import { getParams } from '../helpers/helper.service';

// Auth
export const login = (data) => instance.post(LOGIN, data);


// Notice Type
export const addNoticeType = (data) => instance.post(ADD_NOTICE_TYPE, data);
export const getNoticeTypeList = (queryData) => instance.get(GET_NOTICE_TYPE_LIST + '?' + getParams(queryData));
export const editNoticeType = (id, data) => instance.put(EDIT_NOTICE_TYPE + id, data);
export const noticeTypeEditStatus = (id, data) => instance.put(EDIT_NOTICE_TYPE_STATUS + id, data);
export const noticeTypeDelete = (id, data) => instance.put(DELETE_NOTICE_TYPE + id);

// Depots
export const addDepots = (data) => instance.post(ADD_DEPOTS, data);
export const getDepotsList = (queryData) => instance.get(GET_DEPOTS_LIST + '?' + getParams(queryData));
export const editDepots = (id, data) => instance.put(EDIT_DEPOTS + id, data);
export const depotsEditStatus = (id, data) => instance.put(EDIT_DEPOTS_STATUS + id, data);
export const depotsDelete = (id) => instance.put(DELETE_DEPOTS + id);


// User
export const addUser = (data) => instance.post(ADD_USER, data);
export const addcsvbulkusers = (data) => instance.post(ADD_CSV_BULK_USERS, data);
export const getUserList = () => instance.get(GET_USER_LIST);
export const editUser = (id, data) => instance.put(EDIT_USER + id, data);
export const userEditStatus = (id, data) => instance.put(EDIT_USER_STATUS + id, data);
export const userDelete = (id, data) => instance.put(DELETE_USER + id);

//driverManagement

export const getDriverList = () => instance.get(GET_DRIVER_LIST);
export const changeDriverDepot = (id, data) => instance.post(CHANGE_DRIVER_DEPOTS + id, data);


//noticeManagement
export const getNoticeList = (queryData) => instance.get(GET_NOTICE_LIST + '?' + getParams(queryData));
export const getNoticeTotals = (queryData) => instance.get(GET_NOTICE_TOTALS + '?' + getParams(queryData));
export const addNotice = (data) => instance.post(ADD_NOTICE, data);
export const editNotice = (id, data) => instance.put(EDIT_NOTICE + id, data);
export const deleteNotice = (id) => instance.put(DELETE_NOTICE + id);
export const changeStatusNotice = (id, data) => instance.put(CHANGE_NOTICE_STATUS + id, data);
export const noticeViewReport = (id, queryData) => instance.get(NOTICE_VIEW_REPORT + id + '?' + getParams(queryData));
